angular.module('mercury.modules.stock.predictedorder')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Stock.PredictedOrder', {
    url: '/predicted-order',
    controller: 'ReactCtrl',
  });
}]);
